import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { ATLunchBenefitListItemExtension } from './at-lunch-benefit-list-item.extension';
import { ATLunchBenefitMetadataExtension } from './at-lunch-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('at_lunch')
    .add(BenefitMetadataExtensionInterface, new ATLunchBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new ATLunchBenefitListItemExtension())
    .build(),
);
